export const PADDING_RATIO = 0.12
